<main>
  <div>
    <app-menu></app-menu>
    <aside>
      <header>
        <img src="/assets/images/banner-rensa-training.jpg" alt="Rensa training banner"/>
        <div>
          <h1>Afmelden</h1>
        </div>
      </header>
      <section>
        <div class="gray-container" *ngIf="!unregisterSuccess">
          <div class="normal-text">Je meldt je af voor de training:</div>
          <h2>‘{{training?.title}}’</h2>
          <div class="normal-text">
            op <span class="info">{{(event?.startDateTime * 1000) | date: 'dd/MM/yyyy'}}</span> in <span
            class="info">{{event?.location?.city}}</span>
          </div>
        </div>
        <app-button *ngIf="!unregisterSuccess" (click)="unregister()">Afmelden</app-button>
        <app-feedback [type]="MessageType.ERROR" *ngIf="unregisterError">{{unregisterError}}</app-feedback>
        <div class="green-background" *ngIf="unregisterSuccess">
          <h1>Jammer dat je je hebt afgemeld</h1>
          We hopen je volgende keer te verwelkomen op 1 van onze training!
        </div>
      </section>
    </aside>
  </div>
</main>
<app-footer
  [showAllEventsButton]="true"
></app-footer>
